"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawMobilePhotos(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 763.811 555.5",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M762.811 555.5h-381a1 1 0 110-2h381a1 1 0 010 2z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M711.693 137.309h-.844a4.005 4.005 0 01-4-4v-31.764a4.005 4.005 0 014-4h.844a4.005 4.005 0 014 4v31.764a4.005 4.005 0 01-4 4zM433.773 98.545h-.844a4.005 4.005 0 01-4-4V76.159a4.005 4.005 0 014-4h.844a4.005 4.005 0 014 4v18.386a4.005 4.005 0 01-4 4zM433.773 143.313h-.844a4.005 4.005 0 01-4-4v-18.386a4.005 4.005 0 014-4h.844a4.005 4.005 0 014 4v18.386a4.005 4.005 0 01-4 4z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M673.104 554.478H471.518a34.784 34.784 0 01-34.745-34.745V35.745A34.784 34.784 0 01471.518 1h201.586a34.784 34.784 0 0134.745 34.745v483.988a34.784 34.784 0 01-34.745 34.745z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M673.104 555.478H471.518a35.785 35.785 0 01-35.745-35.745V143.886a4.912 4.912 0 01-2 .427h-.844a5.006 5.006 0 01-5-5v-18.386a5.006 5.006 0 015-5h.844a4.912 4.912 0 012 .427V99.118a4.912 4.912 0 01-2 .427h-.844a5.006 5.006 0 01-5-5V76.159a5.006 5.006 0 015-5h.844a4.912 4.912 0 012 .427V35.745A35.785 35.785 0 01471.518 0h201.586a35.785 35.785 0 0135.745 35.745v61.227a4.91 4.91 0 012-.427h.844a5.006 5.006 0 015 5v31.764a5.006 5.006 0 01-5 5h-.844a4.91 4.91 0 01-2-.428v381.852a35.785 35.785 0 01-35.745 35.745zm-235.33-416.21v380.465a33.783 33.783 0 0033.744 33.745h201.586a33.783 33.783 0 0033.745-33.745V133.261l1.753 2.008a2.992 2.992 0 002.247 1.04h.844a3.003 3.003 0 003-3v-31.764a3.003 3.003 0 00-3-3h-.844a2.992 2.992 0 00-2.247 1.04l-1.753 2.008V35.745A33.783 33.783 0 00673.104 2H471.518a33.783 33.783 0 00-33.745 33.745v40.46L436.02 74.2a2.995 2.995 0 00-2.247-1.04h-.844a3.003 3.003 0 00-3 3v18.386a3.003 3.003 0 003 3h.844a2.995 2.995 0 002.247-1.04l1.753-2.006v26.474l-1.753-2.006a2.995 2.995 0 00-2.247-1.04h-.844a3.003 3.003 0 00-3 3v18.386a3.003 3.003 0 003 3h.844a2.995 2.995 0 002.247-1.04z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M540.945 137.309H485.82a31.903 31.903 0 01-31.867-31.867v-63.9A31.902 31.902 0 01485.82 9.676h55.125a31.902 31.902 0 0131.866 31.866v63.9a31.903 31.903 0 01-31.866 31.867z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M540.945 138.309H485.82a32.904 32.904 0 01-32.867-32.867v-63.9A32.904 32.904 0 01485.82 8.676h55.125a32.904 32.904 0 0132.866 32.866v63.9a32.904 32.904 0 01-32.866 32.867zM485.82 10.676a30.901 30.901 0 00-30.867 30.866v63.9a30.902 30.902 0 0030.867 30.867h55.125a30.902 30.902 0 0030.866-30.867v-63.9a30.901 30.901 0 00-30.866-30.866z",
    fill: "#ccc"
  }), React.createElement("circle", {
    cx: 572.311,
    cy: 273.221,
    r: 26.943,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 487.607,
    cy: 43.235,
    r: 16.81,
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 487.607,
    cy: 103.75,
    r: 16.81,
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 539.157,
    cy: 73.191,
    r: 16.81,
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 487.607,
    cy: 43.235,
    r: 5.883,
    fill: "#b3b3b3"
  }), React.createElement("path", {
    d: "M487.607 50.118a6.884 6.884 0 116.884-6.883 6.891 6.891 0 01-6.884 6.883zm0-11.767a4.884 4.884 0 104.884 4.884 4.889 4.889 0 00-4.884-4.884z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 539.157,
    cy: 73.191,
    r: 5.883,
    fill: "#b3b3b3"
  }), React.createElement("path", {
    d: "M539.157 80.075a6.884 6.884 0 116.883-6.884 6.891 6.891 0 01-6.883 6.884zm0-11.767a4.884 4.884 0 104.883 4.883 4.889 4.889 0 00-4.883-4.883z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 487.607,
    cy: 103.75,
    r: 5.883,
    fill: "#b3b3b3"
  }), React.createElement("path", {
    d: "M487.607 110.633a6.884 6.884 0 116.884-6.884 6.891 6.891 0 01-6.884 6.884zm0-11.767a4.884 4.884 0 104.884 4.883 4.889 4.889 0 00-4.884-4.883zM312.47 181.06l-72.353 112.624a3.369 3.369 0 01-4.655 1.015l-.002-.002L44.275 171.875a2.842 2.842 0 01-.386-.293 3.367 3.367 0 01-.628-4.364l72.353-112.624a3.369 3.369 0 014.655-1.015l.002.002 191.185 122.822a3.369 3.369 0 011.015 4.655z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 138.589,
    cy: 124.807,
    r: 29.567,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M167.35 251.58L45.317 173.181a2.957 2.957 0 01-.433-.33l121.941-62.893a4.803 4.803 0 017.034 4.519l-4.365 91.973-.206 4.403z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    opacity: 0.2,
    style: {
      isolation: 'isolate'
    },
    d: "M167.35 251.579l-41.665-26.767 39.539-16.569 2.847-1.194 1.423-.598-.206 4.403-1.938 40.725z"
  }), React.createElement("path", {
    d: "M235.297 295.23l-105.549-67.807 39.54-16.57 2.846-1.194 51.525-21.594c3.378-1.415 7.683 1.127 8.313 4.664a5.726 5.726 0 01.076.725z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M337.694 176.125a12.132 12.132 0 00-5.255-12.896L122.259 28.203a12.1 12.1 0 00-16.726 3.642L1.916 193.134a12.121 12.121 0 003.641 16.726l210.18 135.025a12.121 12.121 0 0016.726-3.641l103.617-161.29a12.012 12.012 0 001.614-3.829zm-106.429 164.35a10.693 10.693 0 01-14.758 3.212L6.327 208.662a10.693 10.693 0 01-3.213-14.758l103.617-161.29a10.693 10.693 0 0114.758-3.213l210.18 135.026a10.693 10.693 0 013.213 14.758z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M330.777 227.288a12.132 12.132 0 00-11.392-8.01H69.57a12.1 12.1 0 00-12.104 12.104v191.705A12.121 12.121 0 0069.57 435.19h249.815a12.121 12.121 0 0012.104-12.104V231.382a12.012 12.012 0 00-.712-4.094z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M330.777 227.288a12.132 12.132 0 00-11.392-8.01H69.57a12.1 12.1 0 00-12.104 12.104v191.705A12.121 12.121 0 0069.57 435.19h249.815a12.121 12.121 0 0012.104-12.104V231.382a12.012 12.012 0 00-.712-4.094zm-.712 195.799a10.693 10.693 0 01-10.68 10.68H69.57a10.693 10.693 0 01-10.68-10.68V231.382a10.693 10.693 0 0110.68-10.68h249.815a10.693 10.693 0 0110.68 10.68z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M312.222 245.073v133.862a3.369 3.369 0 01-3.368 3.37H81.614a2.84 2.84 0 01-.483-.038 3.367 3.367 0 01-2.887-3.332V245.073a3.369 3.369 0 013.367-3.37h227.24a3.369 3.369 0 013.371 3.368z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 135.524,
    cy: 291.728,
    r: 29.567,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M228.242 382.842H83.197a2.957 2.957 0 01-.542-.043l68.6-118.825a4.803 4.803 0 018.36 0l46.04 79.74 2.205 3.816z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    opacity: 0.2,
    style: {
      isolation: 'isolate'
    },
    d: "M228.242 382.842H178.72l24.31-35.312 1.75-2.543.875-1.272 2.205 3.815 20.382 35.312z"
  }), React.createElement("path", {
    d: "M309.002 382.842H183.55l24.31-35.312 1.75-2.543 31.678-46.018c2.077-3.016 7.073-3.204 9.515-.569a5.724 5.724 0 01.456.569z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M330.777 227.288a12.132 12.132 0 00-11.392-8.01H69.57a12.1 12.1 0 00-12.104 12.104v191.705A12.121 12.121 0 0069.57 435.19h249.815a12.121 12.121 0 0012.104-12.104V231.382a12.012 12.012 0 00-.712-4.094zm-.712 195.799a10.693 10.693 0 01-10.68 10.68H69.57a10.693 10.693 0 01-10.68-10.68V231.382a10.693 10.693 0 0110.68-10.68h249.815a10.693 10.693 0 0110.68 10.68z",
    fill: "#3f3d56"
  }));
}
exports.default = UndrawMobilePhotos;